/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

export const QUARANTINE_STRINGS = {
  tabs: {
    quarantine: 'Quarantine',
    cachedRisk: 'Cached Risk',
    containers: 'Containers',
  },
  notAvailable: {
    title: 'Not available yet',
    description: 'This view will be available in a future release.',
  },
  list: {
    loading: 'Loading quarantined components...',
    loadErrorTitle: 'Could not load quarantined components',
    retry: 'Retry',
    noMatchesTitle: 'No components match your filters',
    noMatchesDescription: 'Try changing or clearing the filters.',
    clearFilters: 'Clear filters',
    emptyTitle: 'No quarantined components',
    emptyDescription: 'Components blocked by Firewall in this instance will appear here.',
    noResults: 'No results',
    activelyInQuarantine: 'actively in quarantine',
    searchPlaceholder: 'Search by policy, component, ecosystem',
    downloadCsv: 'Download CSV',
  },
  columns: {
    severity: 'Severity',
    component: 'Component',
    repository: 'Repository',
    policy: 'Policy Name',
    quarantineTime: 'Quarantine Time',
  },
  filters: {
    severity: 'Severity',
    policy: 'Policy Name',
    ecosystem: 'Ecosystem',
    repository: 'Repository',
  },
  errors: {
    loadList: 'Failed to load quarantined components.',
    loadSummary: 'Failed to load the quarantine summary.',
  },
  truncatedNotice: (limit: string) =>
    `Showing the ${limit} most recent quarantined components. Counts and filters cover only these.`,
  results: (total: string) => `${total} results`,
};
